<div class="delivery-help-popover">
  <section class="delivery-help-popover__body">
    <p class="delivery-help-popover__title">
      {{ 'stores.forms.steps.delivery.title' | translate }}
    </p>
    <p class="delivery-help-popover__description">
      {{ 'stores.forms.steps.delivery.description' | translate }}
    </p>
    <ul class="delivery-help-popover__list">
      <li>{{ 'stores.forms.steps.delivery.bullet1' | translate }}</li>
      <li>{{ 'stores.forms.steps.delivery.bullet2' | translate }}</li>
      <li>{{ 'stores.forms.steps.delivery.bullet3' | translate }}</li>
    </ul>
  </section>
</div>
